import { QA_NAME_REQUEST_BOARD_COLUMN_RETRY } from '../RequestBoard.constants'

import { RequestBoardColumnContentState } from './RequestBoardColumn.constants'
import { RequestBoardColumnCards } from './RequestBoardColumnCards'
import { RequestBoardColumnMessage } from './RequestBoardColumnMessage'
import { RequestBoardColumnSkeleton } from './RequestBoardColumnSkeleton'

function getRequestBoardColumnContentState({ hasError, isLoading, items }) {
  return isLoading
    ? RequestBoardColumnContentState.Loading
    : items.length > 0
      ? RequestBoardColumnContentState.Cards
      : hasError
        ? RequestBoardColumnContentState.Error
        : RequestBoardColumnContentState.Empty
}

export function getRequestBoardColumnContent({
  cardProps,
  column,
  pendingIds,
}) {
  switch (getRequestBoardColumnContentState(column)) {
    case RequestBoardColumnContentState.Loading:
      return <RequestBoardColumnSkeleton />
    case RequestBoardColumnContentState.Cards:
      return (
        <RequestBoardColumnCards
          cardProps={cardProps}
          column={column}
          pendingIds={pendingIds}
        />
      )
    case RequestBoardColumnContentState.Error:
      return (
        <RequestBoardColumnMessage
          actionProps={{
            qaName: QA_NAME_REQUEST_BOARD_COLUMN_RETRY,
            textKey: 'Request.BoardColumnRetryBtnKey',
            onClick: column.handleReload,
          }}
          textKey='Request.BoardColumnLoadErrorKey'
        />
      )
    case RequestBoardColumnContentState.Empty:
      return <RequestBoardColumnMessage textKey='Request.BoardColumnEmptyKey' />
    default:
      return null
  }
}
